/**
 * Import Dependency
 */
import data from '@/data.json';
import selectOne from '@/helpers/selectOne';

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  headers : data.segmenten.headers,
  content : data.segmenten.content
}
const getters = {
  getSegmentsList: state => {
    return state.headers;
  },
  getSegmentById: state => ({ id }) => {
    return selectOne({
      from: state.header, 
      property: 'id', 
      value: id
    });
  },
  getSegmentHeadersByProjectId: state => ({ id }) => {
    return state.headers.filter((item) => {
      return item.project.includes(id);
    });
  },
  getSegmentContentsByHeaderId: state => ({id}) => {
    return state.content.filter((item) => {
      return item.timeline.includes(id);
    })
  }
}



const actions = {}
const mutations = {}

/**
 * Export
 */
export default {
  state,
  getters,
  actions,
  mutations
}
